
define('template!companiesDetailHeaderView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="logo default-upload-image"></div>\n<div class="infos">\n  <div class="name-ctn">\n    <div class="name">' +
((__t = ( _.escape(name) )) == null ? '' : __t) +
'</div>\n    <input type="text" class="name-input" autocomplete="off" maxlength="255" style="display: none;" value="' +
((__t = ( _.escape(name) )) == null ? '' : __t) +
'" />\n    <span class="edit-name" title="' +
((__t = ( _.i18n('common.edit', null, 'Edit') )) == null ? '' : __t) +
'">\n      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"/></svg>\n    </span>\n  </div>\n  <div class="domain">' +
((__t = ( emailDomain )) == null ? '' : __t) +
'</div>\n  <div class="vat">';
 if (vatNumber) { ;
__p +=
((__t = ( _.i18n('common.vatNumber') || 'VAT' )) == null ? '' : __t) +
': ' +
((__t = ( vatNumber )) == null ? '' : __t);
 } ;
__p += '</div>\n</div>\n<div class="tools">\n  <div class="ctn-2">\n    <div class="back-region"></div>\n  </div>\n</div>\n';

}
return __p
};});

